<template>
  <div>
      <!-- Contact Actions Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3 mt-5">
          {{ $t('leads-web.flows.contact_actions_details') }}
        </h5>
      </div>

    <v-client-table
      id="contactActionsTable"
      ref="contactActionsTable"
      name="contactActionsTable"
      :data="value"
      :columns="columns"
      :options="tableOptions">

      <span slot="active" class="no-break" slot-scope="props"> {{props.row.active === true ? $t('modals.buttons.yes') : $t('modals.buttons.no')}}</span>
      <span slot="contact_type" class="no-break" slot-scope="props">{{ props.row.contact_type ? props.row.contact_type.type || "N/A" : "N/A"}}</span>

      <span slot="contact_type_name" class="no-break" slot-scope="props">{{ props.row.contact_type ? props.row.contact_type.name || "N/A" : "N/A"}}</span>

      <span slot="start_time" class="no-break" slot-scope="props">{{ props.row.start_time || "N/A" }}</span>

      <span slot="end_time" class="no-break" slot-scope="props">{{ props.row.end_time || "N/A" }}</span>

    </v-client-table>

      <!------------>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";
import { ClientTable } from 'vue-tables-2'
Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  props: {
    value: {
      type: Array,
      required: false
    },
  },
  data() {
    return {
      columns: ['name', 'active', 'contact_type', 'contact_type_name', 'start_time', 'end_time'],
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns')
        },
        headings: {
          name: this.$t('leads-web.contact_actions.table_headings.name'),
          active: this.$t('leads-web.contact_actions.table_headings.active'),
          contact_type: this.$t('leads-web.contact_actions.table_headings.contact_type'),
          contact_type_name: this.$t('leads-web.contact_actions.table_headings.contact_type_name'),
          start_time: this.$t('leads-web.contact_actions.table_headings.start_time'),
          end_time: this.$t('leads-web.contact_actions.table_headings.end_time'),
        },
        sortable: [],
        sortIcon: {
          is: 'fa-sort',
          base: 'fa fa-fw',
          up: 'fa-sort-up',
          down: 'fa-sort-down'
        },
        skin: 'table table-striped table-hover is-fullwidth',
        columnsDropdown: false,
        pagination: {
          chunk: 10,
          nav: 'scroll'
        }
      }
    }
  },
  mounted() {
  },
  methods: {

  },
  computed: {
  },

}
</script>

<style scoped>
.btn_add {
  padding: 0 !important;
}

.layout.gutter--xl .row:not(:only-child) {
  margin: unset !important;
}
.custom-border-outline {
  border: 2px solid rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}

.custom-multiselect {
  padding-left: 0 !important;
  padding-right: 45px !important;
}

.placeholder-label {
  color:  rgba(194, 194, 194, 0.55)
}
.sort-icon-disabled {
  opacity: 0.2;
}
</style>

<style lang="scss">
@import "~vuestic-ui/src/components/vuestic-sass/vuestic-styles";

.header-lbl{
  padding-left: 5px;
  color: $evollu-dark;
}
</style>
